<app-template [useCard]="false">
    <div class="container pb-4">
        <div class="card col-10 col-md-6 col-lg-4 m-auto shadow mt-3 p-3 cardSelfCheckin ">
            <form class="w-100" *ngIf="!loading" [formGroup]="userForm ">
            <table class="table d-flex justify-content-center text-center" >
                <tbody>
                    <tr>
                        <td>
                            <h2>Bem vindo(a)</h2>
                            <h5>{{ userForm.value.personName }}</h5>
                            <div>Obrigado por sua presença</div>
                            <div >{{ userForm.value.date }}</div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5>{{ userForm.value.conferenceName }}</h5>
                            <div>Encontro presencial</div>
                            <div>{{ userForm.value.meetingName }}</div>
                            <div>{{ userForm.value.localityPlace }}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="text-center">
                <div class="col-6 col-md-6 m-auto">
                    <button type="button" (click)="cancel()" class="btn-green btn-sm btn">
                        Ok
                      </button>
                </div>
            </div>
        </form>
        </div>
    </div>
</app-template>